export default /https?:\/\/(?!refer\.)([a-zA-Z0-9-]+\.)*booksy\.(com|pm)/

